<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xsIEGr/tc-custom/9780226783093.jpg?1731883558629" alt="This image is the cover for the book Seneca"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seneca
      </h1>
      <p class="bookDescription body article font2">
        <b>A selection of Seneca’s most significant letters that illuminate his philosophical and personal life.</b><br/>  <br/> “There is only one course of action that can make you happy. . . . rejoice in what is yours. What is it that is yours? Yourself; the best part of you.” <br/>  <br/> In the year 62, citing health issues, the Roman philosopher Seneca withdrew from public service and devoted his time to writing. His letters from this period offer a window onto his experience as a landowner, a traveler, and a man coping with the onset of old age. They share his ideas on everything from the treatment of enslaved people to the perils of seafaring, and they provide lucid explanations for many key points of Stoic philosophy.<br/>  <br/> This selection of fifty letters brings out the essentials of Seneca’s thought, with much that speaks directly to the modern reader. Above all, they explore the inner life of the individual who proceeds through philosophical inquiry from a state of emotional turmoil to true friendship, self-determination, and personal excellence. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucius Annaeus Senenca, Margaret Graver, A.A. Long
      </h2>
      
      <p class="authorDescription body article"><B>Lucius Annaeus Seneca</B> (4BCE-65CE) was a Roman Stoic philosopher, dramatist, and advisor to Emperor Nero. <B>Margaret Graver</B> is the Aaron Lawrence Professor in Classics at Dartmouth College. Her publications include <I>Cicero on the Emotions: Tusculan Disputations 3 and 4</I>; <I>Stoicism and Emotion</I>; and, in collaboration with A.A. Long, a complete translation of Seneca’s <I>Letters on Ethics</I>. <B>A.A. Long</B> is chancellor’s professor of classics emeritus and affiliated professor of philosophy at the University of California, Berkeley. His books include <I>Greek Models of Mind and Self</I> and <I>Epictetus: How to be Free</I>.&#160;<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7265cd4d